// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-p_gc","galleryThumbnail_active":"c-p_ge","galleryThumbnail__image":"c-p_gf"};